import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { useAuth } from '../../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace('#', '')).get('session_id');
    if (!sessionId) {
      navigate('/login', { replace: true });
      return;
    }
    api
      .post('/auth/google/session', { session_id: sessionId })
      .then(({ data }) => {
        setUser(data.user);
        navigate('/app', { replace: true, state: { user: data.user } });
      })
      .catch((err) => {
        const status = err.response?.status;
        const detail = err.response?.data?.detail || '';
        // Si está pendiente de aprobación, llevamos a la pantalla amistosa
        if (status === 403 && /pendiente/i.test(detail)) {
          navigate('/registro/pendiente', { replace: true, state: { message: detail } });
          return;
        }
        if (status === 403 && /suspend|rechaz/i.test(detail)) {
          toast.error(detail);
          navigate('/login', { replace: true });
          return;
        }
        toast.error(detail || 'No se pudo iniciar sesión con Google. Intenta nuevamente.');
        navigate('/login', { replace: true });
      });
  }, [location, navigate, setUser]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-cnib-navy" data-testid="auth-callback-loading">
      <Loader2 className="h-10 w-10 animate-spin text-orange-500" />
      <p className="text-sm font-medium text-slate-300">Verificando tu cuenta…</p>
    </div>
  );
}
